// Форматирует дату и время события

export function formatEventDateTime(
  start?: string,
  end?: string
): { date: string; time: string } {
  if (!start) return { date: "", time: "" };

  const startDate = new Date(start);
  const endDate = end ? new Date(end) : null;

  const date = startDate.toLocaleDateString("ru-RU", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const startTime = startDate.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });

  let time = startTime;

  if (endDate) {
    const endTime = endDate.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
    });

    // Если дата окончания совпадает с начальной — просто показываем диапазон времени
    if (startDate.toDateString() === endDate.toDateString()) {
      time = `${startTime}–${endTime}`;
    } else {
      // Если дата разная — покажем обе даты
      time = `${startTime} (${date}) – ${endTime} (${endDate.toLocaleDateString(
        "ru-RU",
        { day: "2-digit", month: "long", year: "numeric" }
      )})`;
    }
  }

  return { date, time };
}

export function formatEventDateTimeMin(
  start?: string,
  end?: string
): { date: string; time: string } {
  if (!start) return { date: "", time: "" };

  const startDate = new Date(start);
  const endDate = end ? new Date(end) : null;

  // Сокращённые имена дней и месяцев
  const shortWeekdays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
  const shortMonths = [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек",
  ];

  const weekday = shortWeekdays[startDate.getDay()];
  const day = startDate.getDate();
  const month = shortMonths[startDate.getMonth()];

  const startTime = startDate.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });

  let date = `${weekday}, ${day} ${month}`;
  let time = `${startTime}`;

  // Если есть конец и дата та же — показываем диапазон времени
  if (endDate && startDate.toDateString() === endDate.toDateString()) {
    const endTime = endDate.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
    });
    time = `${startTime}–${endTime}`;
  }

  return { date, time };
}
